export enum ContentDataType { AboutUs, PrivacyPolicy, TermsOfUse, Support, }
